export const SET_TIMEZONES_LIST = 'SET_TIMEZONES_LIST';


export const setTimezones = (timezonesArr) => {
    return {
        type: SET_TIMEZONES_LIST,
        payload: timezonesArr
    }
}